import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { financeApi } from "../../../finance-api-client";
import type { CreateMembershipFee, UpdateMembershipFee } from "../../../types";
import { queryKeys } from "../../query-keys";

export function useMembershipFees(clubId: string | null) {
	return useQuery({
		queryKey: queryKeys.clubPortal.membershipFees(clubId ?? ""),
		queryFn: () => financeApi.fees.list(clubId!),
		enabled: !!clubId,
	});
}

export function useCreateMembershipFee(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (data: CreateMembershipFee) => financeApi.fees.create(clubId, data),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.clubPortal.membershipFees(clubId),
			}),
	});
}

export function useUpdateMembershipFee(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ feeId, data }: { feeId: string; data: UpdateMembershipFee }) =>
			financeApi.fees.update(clubId, feeId, data),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.clubPortal.membershipFees(clubId),
			}),
	});
}

export function useDeleteMembershipFee(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (feeId: string) => financeApi.fees.delete(clubId, feeId),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.clubPortal.membershipFees(clubId),
			}),
	});
}

export function useSyncStripeProduct(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (feeId: string) => financeApi.fees.syncProduct(clubId, feeId),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.clubPortal.membershipFees(clubId),
			}),
	});
}
